/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import actions from 'redux/actions';
import { getProduction } from 'redux/reducers/productions';
import ProductionForm from 'forms/ProductionForm';
import DataLoader from 'components/DataLoader';
import styles from './styles.module.scss';
import { get, defaultTo } from 'lodash';
import { withTranslation } from 'react-i18next';
import protonesUtils from 'utils/protones';

import type {
  ReactRouterProps,
  Fetchable,
  Production,
  SaveProductionParams,
  ReduxState,
  Translate,
} from 'types';

const mapStateToProps = (state: ReduxState, ownProps) => {
  const productionId = ownProps.match.params.productionId;
  const isNew = productionId === 'create';
  return {
    productionId,
    production: getProduction(state),
    isNew,
    ...ownProps,
  };
};

type Props = ReactRouterProps & {
  productionId?: string,
  production: Fetchable<Production>,
  isNew: boolean,
  saveProduction: typeof actions.saveProduction,
  fetchProductionList: typeof actions.fetchProductionList,
  t: Translate,
};

class ProductionEdit extends React.Component<Props, void> {
  _handleSaveProduction = (params: SaveProductionParams) => {
    this.props.saveProduction(params, (production: Production) => {
      this.props.fetchProductionList();
      protonesUtils.goTo(this.props, protonesUtils.routes.productions.get(production.id));
    });
  };

  _getProductionFormTitle() {
    const {
      production: { data },
      isNew,
      productionId,
      t,
    } = this.props;
    if (isNew) {
      return t('DEFINE_NEW_PRODUCTION');
    } else if (data && data.name) {
      return !productionId ? `${t('PRODUCTION')}: ${data.name || ''}` : data.name;
    } else {
      return '';
    }
  }

  _renderProduction = data => {
    const {
      production: { fetching },
    } = this.props;
    const initialValues = {
      id: defaultTo(get(data, 'id'), ''),
      name: defaultTo(get(data, 'name'), ''),
      areaId: defaultTo(get(data, 'area.id'), ''),
      edition: defaultTo(get(data, 'edition'), ''),
      broadcastingId: defaultTo(get(data, 'broadcasting.id'), ''),
      platformId: defaultTo(get(data, 'platform.id'), ''),
      channelId: defaultTo(get(data, 'channel.id'), ''),
      producerName: defaultTo(get(data, 'producer.name'), ''),
      productionTypeId: defaultTo(get(data, 'productionType.id'), ''),
      broadcastTypeId: defaultTo(get(data, 'broadcastType.id'), ''),
    };
    return (
      <div className={styles.content}>
        <ProductionForm
          initialValues={initialValues}
          isLoading={fetching}
          title={this._getProductionFormTitle()}
          save={this._handleSaveProduction}
        />
      </div>
    );
  };

  render() {
    const {
      production: { fetching, error, data },
    } = this.props;
    return (
      <DataLoader loading={fetching} error={error} data={data} render={this._renderProduction} />
    );
  }
}

export default withTranslation()(
  withRouter(
    connect(
      mapStateToProps,
      actions
    )(ProductionEdit)
  )
);
